import { MinimalLiveVideoSkinElement } from '../../presets/live-video/minimal-skin';
import { safeDefine } from '../../registration/safe-define';
import '../../internal/skins/minimal-live-video/register';

safeDefine(MinimalLiveVideoSkinElement);
